import axios from '../utils/request';
// eslint-disable-next-line import/prefer-default-export
// 获取优惠券
export function getCouponList(params){
    return axios.get('/coupon',params)
}
// 领取优惠券
export function receiveCoupon(data){
    return axios.post('/coupon',data)
}
// 获取用户优惠券
export function userCoupon(params){
    return axios.get(`/user_coupon?status=${params.status}`,)
}
// 获取当前票可用优惠券
export function availableCoupon(id,price){
    return axios.get(`/coupon/${id}?price=${price}`)
}